import { createContext, useContext } from 'react';
import type { ApolloError } from '@apollo/client';
import type { PriceType, ProductPrices } from '../types';

export type PricingContextValue = {
    productPrices: ProductPrices | undefined;
    lowestPrice: PriceType | undefined;
    loading: boolean;
    error: ApolloError | undefined;
};

export const PricingContext = createContext<PricingContextValue | undefined>(undefined);

export function usePricingProviderContext(): PricingContextValue {
    const context = useContext(PricingContext);
    if (!context) {
        throw new Error('usePricingProviderContext must be used within a PricingProvider');
    }
    return context;
}
